import './App.css';
import { NavBar } from './components/navbar';
import 'bootstrap/dist/css/bootstrap.min.css';
function App() {
  return (
    <div>
  <NavBar />
    </div>
      
  );
}

export default App;
